// Manufacturing → Fulfill mode panel (scaffold; gated by VITE_MFG_SCAFFOLD_TABS).
// Primary action: Fulfill order and deduct inventory.
import { useEffect, useState } from "react";
import { SectionCard } from "@/components/common/SectionCard";
import { ManufacturingGateBanner, ManufacturingToast } from "./ManufacturingGateBanner";
import { useManufacturingEntitlementGate } from "./useManufacturingEntitlementGate";

export function ManufacturingFulfillPanel() {
  const gate = useManufacturingEntitlementGate();
  const [toast, setToast] = useState<string | null>(null);

  function scaffoldAction(name: string) {
    setToast(`${name} is scaffolded (UI only)`);
  }

  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(null), 2400);
    return () => window.clearTimeout(t);
  }, [toast]);

  return (
    <div className="w-full text-left space-y-4">
      <div className="flex flex-wrap items-center gap-3 justify-between">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Fulfill</h2>
      </div>

      <ManufacturingToast message={toast} />
      <ManufacturingGateBanner gate={gate} />

      {gate.enabled ? (
        <>
          <SectionCard title="Select a style">
            <ul className="divide-y divide-gray-100 dark:divide-zinc-700">
              <li>
                <button
                  type="button"
                  className="w-full rounded-md px-3 py-2 text-left text-sm text-gray-800 hover:bg-gray-50 dark:text-zinc-200 dark:hover:bg-zinc-800/60"
                  onClick={() => scaffoldAction("Select Style: Utility")}
                >
                  Utility
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="w-full rounded-md px-3 py-2 text-left text-sm text-gray-800 hover:bg-gray-50 dark:text-zinc-200 dark:hover:bg-zinc-800/60"
                  onClick={() => scaffoldAction("Select Style: Lofted Barn")}
                >
                  Lofted Barn
                </button>
              </li>
            </ul>
          </SectionCard>

          <button
            type="button"
            className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white hover:bg-indigo-700"
            onClick={() => scaffoldAction("Fulfill Order")}
          >
            Fulfill order and deduct inventory
          </button>
        </>
      ) : null}
    </div>
  );
}
